import { CountryUIConfigName } from '../constants';
import { CountryUIFeature } from '../country-ui-feature';

export const USCountryUIConfig = [new CountryUIFeature(CountryUIConfigName.ShippingSuppliesLinkEnabled)];
